import React from 'react'
import { Button, Spin, Modal } from 'antd'
import users from '@services/users'
import { isPrepaymentExpired } from '@utils/prepaymentDateUtils'

interface SubscriptionStatusProps {
    clientInfo: any
    getClientInfo?: () => void | Promise<void>
    onConfirm: (arg1: boolean, arg2: string) => void
    roles: string[]
    loading_sto?: boolean
    onOpenRedoPayment?: () => void
}

interface SubscriptionStatusState {
    open: boolean
    checking: boolean
}

class SubscriptionStatus extends React.Component<SubscriptionStatusProps, SubscriptionStatusState> {
    constructor(props: SubscriptionStatusProps) {
        super(props)
        this.state = {
            open: false,
            checking: false
        }
    }

    updateStatus = async intendedStatus => {
        const { clientInfo, getClientInfo, onConfirm, onOpenRedoPayment } = this.props
        this.setState({ checking: true })

        let currentStatus = clientInfo.subscription_status
        try {
            const res = await users.getClient({ user_id: clientInfo.id })
            currentStatus = res.data.subscription_status
            if (getClientInfo) {
                getClientInfo()
            }
        } catch (e) {
            console.log('failed to fetch fresh client info', e)
        }

        const isAlreadyInDesiredState =
            (intendedStatus === 'BLOCKED' && currentStatus === 'BLOCKED') ||
            (intendedStatus === 'ACTIVE' && currentStatus !== 'BLOCKED' && currentStatus !== 'AWAITING_BANK_TRANSFER')

        if (isAlreadyInDesiredState) {
            const msg = intendedStatus === 'BLOCKED' ? 'הלקוח כבר חסום' : 'הלקוח כבר פעיל'
            this.setState({ open: false, checking: false })
            Modal.info({ title: msg, okText: 'אישור' })
            return
        }

        this.setState({ checking: false })

        const initiatorTitle = intendedStatus === 'BLOCKED' ? 'SUBSCRIPTION_BLOCKED' : 'SUBSCRIPTION_ACTIVE'

        const isExpiredPrepayment =
            intendedStatus === 'ACTIVE' &&
            (currentStatus === 'BLOCKED' || currentStatus === 'AWAITING_BANK_TRANSFER') &&
            isPrepaymentExpired(clientInfo.prepayment_until)

        this.setState({ open: false })
        if (isExpiredPrepayment && onOpenRedoPayment) {
            onOpenRedoPayment()
            return
        }

        onConfirm(true, initiatorTitle)
    }

    render() {
        const { open, checking } = this.state
        const {
            clientInfo: { subscription_status: status },
            roles,
            loading_sto
        } = this.props

        return (
            <div>
                {['ACTIVE'].includes(status) && (roles.includes('admin') || roles.includes('money')) && (
                    <div>
                        {!open && (
                            <Button disabled={loading_sto} onClick={() => this.setState({ open: true })}>
                                {loading_sto ? <Spin size={'small'} /> : 'חסימת מנוי'}
                            </Button>
                        )}
                        {open && (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <h6>{'האם לחסום מינוי?'}</h6>
                                <div style={{ marginRight: '10px' }}>
                                    <Button disabled={checking} onClick={() => this.updateStatus('BLOCKED')}>
                                        {checking ? <Spin size={'small'} /> : 'אישור'}
                                    </Button>
                                    <Button disabled={checking} onClick={() => this.setState({ open: false })}>
                                        {'ביטול'}
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {['BLOCKED', 'AWAITING_BANK_TRANSFER'].includes(status) && (
                    <div>
                        {!open && (
                            <div style={{ display: 'flex' }}>
                                {roles.includes('admin') || roles.includes('money') ? (
                                    <>
                                        <div style={{ ...style.button, ...style.buttonRight } as React.CSSProperties}>
                                            <span>{'המינוי חסום'}</span>
                                        </div>

                                        <div
                                            style={{ ...style.button, ...style.buttonLeft }}
                                            onClick={() => (loading_sto ? null : this.setState({ open: true }))}
                                        >
                                            <span>{loading_sto ? <Spin size={'small'} /> : 'הפעלת מינוי'}</span>
                                        </div>
                                    </>
                                ) : (
                                    <div
                                        style={
                                            {
                                                ...style.button,
                                                ...style.buttonRight,
                                                borderRadius: '4px'
                                            } as React.CSSProperties
                                        }
                                    >
                                        <span>{'המינוי חסום'}</span>
                                    </div>
                                )}
                            </div>
                        )}

                        {open && (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <h6>{'האם להפעיל מינוי?'}</h6>
                                <div style={{ marginRight: '10px' }}>
                                    <Button disabled={checking} onClick={() => this.updateStatus('ACTIVE')}>
                                        {checking ? <Spin size={'small'} /> : 'אישור'}
                                    </Button>
                                    <Button disabled={checking} onClick={() => this.setState({ open: false })}>
                                        {'ביטול'}
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        )
    }
}

const style = {
    button: {
        background: 'white',
        border: 'solid 1px #d1d1d1',
        height: '34px',
        paddingInline: '15px',
        fontSize: '14px',
        // marginTop: '5px',
        // marginBottom: '5px',
        display: 'flex',
        alignItems: 'center'
    },
    buttonRight: { color: 'red', borderRadius: '0 4px 4px 0', fontWeight: '600', fontSize: '16px' },
    buttonLeft: { cursor: 'pointer', borderRadius: '4px 0 0 4px' }
}

export default SubscriptionStatus
